import register from '@/components/features/cms/blocks/AuthorCard/register';
import { AuthorCard } from './AuthorCard';

register(AuthorCard);
